import { ValidatorFn } from '@angular/forms';
import { CompanyExistsValidator } from '@shared/validators/company/company-exists';

export class U2bCompanyValidators {
    public static companyExists(message?: string): ValidatorFn {
        return new CompanyExistsValidator(message).asValidatorFn();
    }
}
